import * as React from "react"

import * as commonStyles from "../styles/common.module.css"
import * as styles from "./contentcontainer.module.css"

const ContentContainer = ({ children }) => {

  return (
    <div className={`${styles.contentContainer} ${commonStyles.iabContentContainer}`}>
      {children}
      <p>&nbsp;</p>
    </div>
  )
}

export default ContentContainer
 